import React from 'react'

const BrandingContext = React.createContext(null)

export default BrandingContext
